import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useReadChannelPlayerBaseInfo } from './use-read-channel-player-base-info';

export const useChannelCurrentStream = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);
    const onlineStreams = baseInfo?.onlineStreams;

    return useCurrentStream(onlineStreams?.streams);
};
